import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  Divider,
  Alert,
  LinearProgress,
} from '@mui/material';
import { examAPI } from '../services/api';
import {
  fetchExamsStart,
  fetchExamsSuccess,
  fetchExamsFailure,
} from '../store/slices/examSlice';

const StudentDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { exams, loading, error } = useSelector((state) => state.exam);

  useEffect(() => {
    const fetchExams = async () => {
      dispatch(fetchExamsStart());
      try {
        const response = await examAPI.getAssignedExams();
        if (response.data.success) {
          dispatch(fetchExamsSuccess(response.data));
        } else {
          dispatch(fetchExamsFailure(response.data.message || 'Failed to fetch exams'));
        }
      } catch (error) {
        console.error('Error fetching exams:', error);
        dispatch(fetchExamsFailure(error.response?.data?.message || 'Failed to fetch exams'));
      }
    };

    fetchExams();
  }, [dispatch]);

  const handleStartExam = (examId) => {
    navigate(`/take-exam/${examId}`);
  };

  const handleViewResults = (examId) => {
    navigate(`/results/${examId}`);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography component="h1" variant="h4" gutterBottom>
              Welcome, {user?.fullName}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Student Dashboard
            </Typography>
          </Paper>
        </Grid>

        {error && (
          <Grid item xs={12}>
            <Alert severity="error">{error}</Alert>
          </Grid>
        )}

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Available Exams
            </Typography>
            {loading ? (
              <LinearProgress />
            ) : (
              <Grid container spacing={3}>
                {!exams || exams.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography>No exams available.</Typography>
                  </Grid>
                ) : (
                  exams.map((exam) => (
                    <Grid item xs={12} sm={6} md={4} key={exam.id}>
                      <Card>
                        <CardContent>
                          <Typography variant="h6" gutterBottom>
                            {exam.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Duration: {exam.time_limit} minutes
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Assigned: {new Date(exam.assigned_at).toLocaleDateString()}
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            size="small"
                            color="primary"
                            onClick={() => handleStartExam(exam.id)}
                          >
                            Start Exam
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))
                )}
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default StudentDashboard; 